import { useWatch } from 'react-hook-form/dist/index.ie11';

type useShowMaxInvoiceAmountReturnType = {
  showMaxInvoiceInput: boolean;
};

export function useShowMaxInvoiceAmount(): useShowMaxInvoiceAmountReturnType {
  const { invoicePaymentMethod } = useWatch({
    name: ['invoicePaymentMethod'],
  });

  return {
    showMaxInvoiceInput: invoicePaymentMethod === 'CREDIT_CARD_PRIMARY',
  };
}
